export class ReviewFormConfigModel {
    label: string;
    value: string;
    formControlName: string;
}
